function Section({ title, children }) {
    return (
        <div>
            <h3 className="font-display text-lg text-[#0B132B] font-medium mb-2 tracking-tight">
                {title}
            </h3>
            {children}
        </div>
    );
}

function EditorSection() {
    return (
        <Section title="Éditeur du site">
            <p className="mb-4">
                <span className="text-[#0B132B] font-medium">
                    Données &amp; Droit
                </span>{" "}
                est le nom commercial utilisé par Simon Marie pour son
                activité indépendante.
            </p>
            <p>
                Éditeur&nbsp;: Simon Marie
                <br />
                Profession libérale non réglementée
                <br />
                Régime micro entrepreneur
                <br />
                Titre professionnel&nbsp;: Consultant en protection des
                données personnelles et conformité réglementaire
                <br />
                Activité&nbsp;: Conseil en protection des données
                personnelles, pratiques numériques et conformité
                réglementaire pour dirigeants, indépendants et structures
                patrimoniales.
            </p>
        </Section>
    );
}

function ContactSection() {
    return (
        <Section title="Coordonnées">
            <p>
                Adresse&nbsp;:
                <br />
                1 rue Marguerin
                <br />
                75014 Paris
                <br />
                France
                <br />
                <br />
                Téléphone&nbsp;:{" "}
                <a
                    href="tel:+33608033203"
                    className="text-[#0B132B] underline underline-offset-2 decoration-slate-300 hover:decoration-[#0B132B] tabular-nums"
                >
                    06 08 03 32 03
                </a>
                <br />
                Contact écrit&nbsp;: via le formulaire de contact accessible
                depuis la page d'accueil.
            </p>
        </Section>
    );
}

function IdentificationSection() {
    return (
        <Section title="Identification">
            <p>
                SIREN&nbsp;:{" "}
                <span className="tabular-nums">437 816 903</span>
                <br />
                Statut&nbsp;: Profession libérale non réglementée
                <br />
                Régime&nbsp;: Micro entrepreneur
                <br />
                Nom commercial&nbsp;: Données &amp; Droit
            </p>
        </Section>
    );
}

function HostingSection() {
    return (
        <Section title="Hébergement">
            <p>
                Le site est hébergé par Netlify, Inc.
                <br />
                44 Montgomery Street, Suite 300
                <br />
                San Francisco, CA 94104
                <br />
                États-Unis
                <br />
                <br />
                Site de l'hébergeur&nbsp;:{" "}
                <a
                    href="https://www.netlify.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0B132B] underline underline-offset-2 decoration-slate-300 hover:decoration-[#0B132B]"
                >
                    https://www.netlify.com
                </a>
            </p>
        </Section>
    );
}

function IpSection() {
    return (
        <Section title="Propriété intellectuelle">
            <p className="mb-4">
                L'ensemble des contenus présents sur ce site, notamment les
                textes, la structure, l'identité visuelle, le logo
                «&nbsp;Données &amp; Droit&nbsp;» et les éléments graphiques,
                est la propriété de Simon Marie, sauf mention contraire.
            </p>
            <p>
                Toute reproduction, représentation, modification, diffusion
                ou exploitation, totale ou partielle, sans autorisation
                préalable est interdite.
            </p>
        </Section>
    );
}

export function LegalMentions() {
    return (
        <section
            className="border-b border-slate-200 bg-white"
            data-testid="legal-mentions"
        >
            <div className="mx-auto max-w-4xl px-6 md:px-12 lg:px-16 py-16 md:py-20">
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#0B132B] font-medium mb-10">
                    Mentions légales
                </h2>

                <div className="space-y-8 text-base text-slate-600 leading-relaxed">
                    <EditorSection />
                    <ContactSection />
                    <IdentificationSection />
                    <Section title="Site">
                        <p>Nom de domaine&nbsp;: donnees-et-droit.fr</p>
                    </Section>
                    <HostingSection />
                    <IpSection />
                    <Section title="Contact">
                        <p>
                            Pour toute question relative au site, à l'activité
                            ou aux contenus publiés, utiliser le formulaire de
                            contact accessible depuis la page d'accueil.
                        </p>
                    </Section>
                </div>
            </div>
        </section>
    );
}
